export default {
  navHome: "หน้าแรก",
  navProducts: "ผลิตภัณฑ์",
  navCases: "กรณีศึกษาการใช้งาน",
  navAbout: "เกี่ยวกับเรา",
  deliverTo: "จัดส่งไปที่:",
  langCurrencyLabel: "ภาษาไทย",
  localeLangTitle: "ตั้งค่าภาษา",
  localeLangDesc: "เลือกภาษาที่คุณต้องการ คุณสามารถอัปเดตการตั้งค่านี้ได้ตลอดเวลา",
  language: "ภาษา",
  save: "บันทึก",
  coreProducts: "สนับสนุนการสร้างสรรค์ในโลกแห่งความเป็นจริง",
  coreProductsDesc: "จากไอเดียสู่ธุรกิจ — YONGYUAN มอบเครื่องพิมพ์ UV เครื่องพิมพ์ป้ายคริสตัล เครื่องพิมพ์ทรงกระบอกความเร็วสูง เครื่องพิมพ์ DTF และ DTG เปลี่ยนความคิดสร้างสรรค์เป็นผลิตภัณฑ์ แบรนด์ และโอกาส",
  scenariosTitle: "โซลูชันสำหรับทุกสถานการณ์",
  scenariosDesc: "ไม่ว่าคุณจะสร้างแบรนด์ พัฒนาธุรกิจเสริม หรือแสวงหาความหลงใหลในการสร้างสรรค์ YONGYUAN มีโซลูชันที่ตอบโจทย์ความต้องการของคุณ",
  scenarioStudio: "สตูดิโอ",
  scenarioStudioDesc: "การปรับแต่งมูลค่าสูง ต้นแบบล็อตเล็ก และการสร้างแบรนด์",
  scenarioRetail: "ร้านค้าแบรนด์",
  scenarioRetailDesc: "เพิ่มเวลาที่ลูกค้าอยู่ในร้านและยอดขายในร้าน",
  scenarioMarket: "ตลาดนัด",
  scenarioMarketDesc: "ปรับแต่งหน้างาน ขายสินค้าสำเร็จรูป และรายได้เสริม",
  scenarioEnterprise: "การปรับแต่งองค์กร",
  scenarioEnterpriseDesc: "การปรับแต่งแบบกลุ่ม สินค้าแบรนด์ และของขวัญองค์กร",
  scenarioEcommerce: "ขายสดออนไลน์",
  scenarioEcommerceDesc: "ตัวอย่างสินค้าฮิต จัดหาแบบยืดหยุ่น และเปิดตัวสินค้าอย่างรวดเร็ว",
  scenarioStore: "ร้านค้าออนไลน์",
  scenarioStoreDesc: "ปรับแต่งร้าน สินค้าฮิต และการดำเนินงานที่แตกต่าง",
  scenarioFactory: "การผลิตในโรงงาน",
  scenarioFactoryDesc: "การผลิตแบบกลุ่ม ผลผลิตที่เสถียร และการดำเนินงานที่คุ้มค่า",
  scenarioAdvertising: "การผลิตโฆษณา",
  scenarioAdvertisingDesc: "ป้าย วัสดุจัดแสดง และวัสดุกิจกรรม",
  industries: "การใช้งานในอุตสาหกรรม",
  industriesDesc: "โซลูชันการพิมพ์อิงค์เจ็ทดิจิทัลสำหรับการพิมพ์สีในอุตสาหกรรมต่างๆ",
  applicationsTitle: "ปลดล็อกการใช้งานวัสดุและสีที่หลากหลายสำหรับความต้องการในชีวิตประจำวันและเชิงพาณิชย์",
  applicationsDesc: "อุปกรณ์พิมพ์ UV ของ YONGYUAN ออกแบบมาสำหรับวัสดุและสถานการณ์กระบวนการที่หลากหลาย สนับสนุนทั้งการปรับแต่งส่วนบุคคลและการผลิตขนาดใหญ่",
  casesHeroDesc: "ครอบคลุมการใช้งานในอุตสาหกรรมกว่า 1200 รายการ รองรับวัสดุที่พิมพ์ได้หลายหมื่นชนิด มอบโซลูชันการพิมพ์ดิจิทัลสำหรับธุรกิจที่หลากหลาย",
  casesBreadcrumbHome: "หน้าแรก",
  casesBreadcrumbCenter: "กรณีศึกษาการใช้งาน",
  casesEmpty: "ยังไม่มีกรณีศึกษาในหมวดหมู่นี้",
  customerStoriesTitle: "ได้รับความไว้วางใจจากลูกค้าทั่วโลก",
  customerStoriesSubtitle: "การติดตั้งจริง ลูกค้าจริง ธุรกิจการพิมพ์จริงใน 172 ประเทศ",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "เครื่องพิมพ์ที่ส่งมอบ",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "ประเทศที่ให้บริการ",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "ปีแห่งประสบการณ์",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "การสนับสนุนทางเทคนิค",
  customerStoriesPlaceholder: "เพิ่มรูปลูกค้า",
  customerStoriesPhotoAlt: "ลูกค้า YONGYUAN กับเครื่องพิมพ์",
  servicePartnerTitle: "พบกับทีมบริการ YONGYUAN พันธมิตรด้านความคิดสร้างสรรค์ของคุณ",
  servicePartnerDesc: "เครือข่ายบริการทั่วโลกและระบบสนับสนุนมืออาชีพเพื่อปกป้องประสิทธิภาพอุปกรณ์และการเติบโตของธุรกิจของคุณ",
  serviceSupportTitle: "การสนับสนุนมาตรฐาน",
  serviceSupportDesc: "คำแนะนำการติดตั้ง การฝึกอบรมพื้นฐาน และความช่วยเหลือในการใช้งานประจำวันเพื่อให้อุปกรณ์ทำงานได้อย่างเชื่อถือได้",
  servicePresaleTitle: "สาธิตและให้คำปรึกษาก่อนขาย",
  servicePresaleDesc: "การสาธิตโซลูชันและคำแนะนำรุ่นที่เหมาะกับสถานการณ์การใช้งานและความต้องการด้านกำลังการผลิตของคุณ",
  serviceLifetimeTitle: "การสนับสนุนทางเทคนิคตลอดชีพ",
  serviceLifetimeDesc: "การตอบสนองทางเทคนิคอย่างต่อเนื่องและการสนับสนุนกระบวนการเพื่อการพัฒนาธุรกิจระยะยาวของคุณ",
  serviceCareTitle: "อัปเกรดเป็น YONGYUAN Care",
  serviceCareDamageTitle: "การคุ้มครองความเสียหายจากอุบัติเหตุ",
  serviceCareDamageDesc: "แผนคุ้มครองที่ครอบคลุมมากขึ้นเพื่อลดความสูญเสียจากเหตุการณ์ที่ไม่คาดคิด",
  serviceCareExchangeTitle: "บริการแลกเปลี่ยนอย่างรวดเร็ว",
  serviceCareExchangeDesc: "การจัดเตรียมแลกเปลี่ยนอย่างรวดเร็วแบบลำดับความสำคัญภายใต้เงื่อนไขที่เหมาะสมเพื่อเร่งการคืนทุน",
  viewProduct: "ดูผลิตภัณฑ์",
  learnMore: "เรียนรู้เพิ่มเติม",
  catUv: "เครื่องพิมพ์ UV แบนราบ",
  catCylinder: "เครื่องพิมพ์ทรงกระบอก",
  catCrystal: "เครื่องพิมพ์ป้ายคริสตัล",
  catDtf: "เครื่องพิมพ์ DTF",
  catDtg: "เครื่องพิมพ์ DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "โทร: 17748697567 ผู้จัดการ Tang",
  email: "อีเมล: sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. สงวนลิขสิทธิ์",
  productsHeroTitle: "ผลิตภัณฑ์",
  productsHeroDesc: "ผลิตภัณฑ์ครบวงจร UV แบนราบ ทรงกระบอก ป้ายคริสตัล DTF และ DTG สำหรับความต้องการด้านกำลังการผลิตและการใช้งานที่หลากหลาย",
  productsBreadcrumbHome: "หน้าแรก",
  productsBreadcrumbCenter: "ผลิตภัณฑ์",
  productsEmpty: "ผลิตภัณฑ์ในหมวดหมู่นี้จะเปิดตัวเร็วๆ นี้",
  productsQuoteTitle: "ขอโซลูชันและใบเสนอราคา",
  productsQuoteDesc: "แบ่งปันสถานการณ์การใช้งานและความต้องการด้านกำลังการผลิตของคุณ เราจะแนะนำโซลูชันอุปกรณ์ที่เหมาะสม",
  productsContact: "ติดต่อเรา",
  aboutHeroTitle: "เกี่ยวกับ Yongyuan",
  aboutHeroDesc: "17 ปีมุ่งเน้นการวิจัย พัฒนา และผลิตอุปกรณ์พิมพ์ UV",
  productA23Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 6 สีสำหรับโต๊ะทำงาน",
  productA23Feature1: "ขนาดพิมพ์ A4",
  productA23Feature2: "ระบบจ่ายหมึกอัจฉริยะ",
  productA23Feature3: "ตรวจจับความสูงอัตโนมัติด้วยอินฟราเรด",
  productA35Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 6 สีสำหรับโต๊ะทำงาน",
  productA35Feature1: "ขนาดพิมพ์ A3+",
  productA35Feature2: "ระบบจ่ายหมึกอัจฉริยะ",
  productA35Feature3: "ตรวจจับความสูงอัตโนมัติด้วยอินฟราเรด",
  productA43Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 8 สีระดับเรือธง",
  productA43Feature1: "ขนาดพิมพ์ A3",
  productA43Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA43Feature3: "ระบบจ่ายหมึกอัจฉริยะ",
  productA46Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 8 สีระดับเรือธง",
  productA46Feature1: "ขนาดพิมพ์ A2",
  productA46Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA46Feature3: "ระบบจ่ายหมึกอัจฉริยะ",
  productA57Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 8 สีระดับเรือธง",
  productA57Feature1: "ขนาดพิมพ์ A2+",
  productA57Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA57Feature3: "ระบบจ่ายหมึกอัจฉริยะ",
  productA69Subtitle: "เครื่องพิมพ์ UV อัจฉริยะ 8 สีระดับเรือธง",
  productA69Feature1: "ขนาดพิมพ์ A1",
  productA69Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA69Feature3: "ระบบจ่ายหมึกอัจฉริยะ",
  productA1216Subtitle: "เครื่องพิมพ์ UV แบนราบขนาดใหญ่ระดับเรือธง",
  productA1216Feature1: "ขนาดพิมพ์ 1200×1600cm",
  productA1216Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA1216Feature3: "ระบบจัดตำแหน่งด้วยภาพ",
  productA2513Subtitle: "เครื่องพิมพ์ UV แบนราบขนาดใหญ่ระดับเรือธง",
  productA2513Feature1: "ขนาดพิมพ์ 2500×1300cm",
  productA2513Feature2: "การกำหนดค่าหัวพิมพ์หลายแบบ",
  productA2513Feature3: "ระบบจัดตำแหน่งด้วยภาพ",
  productCylinderElfSubtitle: "เครื่องพิมพ์ทรงกระบอกความเร็วสูง 360°",
  productCylinderElfFeature1: "พิมพ์ 360°",
  productCylinderElfFeature2: "ปรับแต่งแก้วและขวด",
  productCylinderElfFeature3: "เปลี่ยนอุปกรณ์จับอย่างรวดเร็ว",
  productCupPlusSubtitle: "โซลูชันพิมพ์แก้วและขวดหลายขนาด",
  productCupPlusFeature1: "อุปกรณ์จับหลายขนาด",
  productCupPlusFeature2: "ประสิทธิภาพการผลิตสูง",
  productCupPlusFeature3: "ผลผลิตที่เสถียร",
  productCrystal60Subtitle: "ระบบพิมพ์และฟอยล์ป้ายคริสตัลแบบครบวงจร",
  productCrystal60Feature1: "ความกว้าง 60cm",
  productCrystal60Feature2: "รวมการพิมพ์และฟอยล์",
  productCrystal60Feature3: "ระบบรับม้วนอย่างมีประสิทธิภาพ",
  productCrystalC60UltraFeature1: "ความกว้าง 60 ซม.",
  productCrystalC60UltraFeature2: "ทอง/เงิน/ฉลากซิลicone 3D หลายรูปแบบ",
  productCrystalC60UltraFeature3: "ผลิตจำนวนมาก",
  productCrystal30Subtitle: "เครื่องพิมพ์ป้ายคริสตัลขนาดกะทัดรัดความแม่นยำสูง",
  productCrystal30Feature1: "พิมพ์แม่นยำขนาดกะทัดรัด",
  productCrystal30Feature2: "ใช้งานง่าย",
  productCrystal30Feature3: "ปรับแต่งส่วนบุคคล",
  productDtf60Subtitle: "เครื่องพิมพ์ถ่ายโอน DTF หมึกขาว",
  productDtf60Feature1: "ถ่ายโอน DTF หมึกขาว",
  productDtf60Feature2: "ชั้นสีที่หลากหลาย",
  productDtf60Feature3: "อุปกรณ์เสริมเสื้อผ้า",
  productDtfF20Subtitle: "เครื่องพิมพ์ DTF หมึกขาวตั้งโต๊ะขนาดเล็กที่สุดในอุตสาหกรรม",
  productDtfF20Feature1: "ขนาด A4",
  productDtfF20Feature2: "ปรับแต่งล็อตเล็ก",
  productDtfF20Feature3: "ระบบหมึกอัจฉริยะ",
  productDtfF30Subtitle: "เครื่องพิมพ์ DTF หมึกขาวตั้งโต๊ะ",
  productDtfF30Feature1: "ขนาด A3",
  productDtfF30Feature2: "หัวพิมพ์เดี่ยว แบบมือ/อัตโนมัติ",
  productDtfF30Feature3: "ระบบหมึกอัจฉริยะ",
  productDtfF30ProSubtitle: "เครื่องพิมพ์ DTF หมึกขาว",
  productDtfF30ProFeature1: "ขนาด A3",
  productDtfF30ProFeature2: "หัวคู่ พร้อมม้วนฟิล์มอัตโนมัติ",
  productDtfF30ProFeature3: "ระบบหมึกอัจฉริยะ",
  productDtfF33Subtitle: "เครื่องพิมพ์ DTF หมึกขาว",
  productDtfF33Feature1: "ขนาด A3",
  productDtfF33Feature2: "หัวพิมพ์เดี่ยว แบบมือ/อัตโนมัติ",
  productDtfF33Feature3: "ระบบหมึกอัจฉริยะ",
  productDtfF70ProSubtitle: "เครื่องพิมพ์ DTF หมึกขาวกว้าง 70 ซม.",
  productDtfF70ProFeature1: "ขนาด A2",
  productDtfF70ProFeature2: "ตัวเลือกหัวพิมพ์ 2–4 หัว",
  productDtfF70ProFeature3: "ระบบป้อนและส่งออกอัตโนมัติ",
  productDtfF70ProFeature4: "โหมดพิมพ์ต่ออัจฉริยะ",
  productDtf30Subtitle: "เครื่องพิมพ์ DTF หมึกขาวขนาดกะทัดรัด",
  productDtf30Feature1: "ปรับแต่งล็อตเล็ก",
  productDtf30Feature2: "การแสดงสีที่แม่นยำ",
  productDtf30Feature3: "ใช้งานง่าย",
  productDtgPrintSubtitle: "เครื่องพิมพ์ดิจิทัลพิมพ์ตรงบนเสื้อผ้า",
  productDtgPrintFeature1: "พิมพ์ตรงหลายวัสดุ",
  productDtgPrintFeature2: "ปริมาณงานสูง",
  productDtgPrintFeature3: "เสถียรและทนทาน",
  productDtg3250DSubtitle: "รุ่น DTF & DTG 2-in-1 เพียงรุ่นเดียวในอุตสาหกรรม",
  productDtg3250DFeature1: "ขนาด A3+",
  productDtg3250DFeature2: "โหมดพิมพ์ DTF & DTG สองกระบวนการ",
  productDtg3250DFeature3: "ระบบหมึกอัจฉริยะ",
  productDtg3646TSubtitle: "เครื่องพิมพ์ DTG สองสถานี",
  productDtg3646TFeature1: "โหมดผลิตต่อเนื่อง",
  productDtg3646TFeature2: "เพิ่มประสิทธิภาพการผลิต 100%",
  productDtg3646TFeature3: "ระบบหมึกอัจฉริยะ",
  productDtgMaxSubtitle: "เครื่องพิมพ์ DTG ดิจิทัลระดับอุตสาหกรรม",
  productDtgMaxFeature1: "กำลังการผลิตระดับอุตสาหกรรม",
  productDtgMaxFeature2: "เสถียรและทนทาน",
  productDtgMaxFeature3: "ทำงานต่อเนื่อง",
  app01Title: "เคสโทรศัพท์",
  app02Title: "ลูกกอล์ฟ",
  app03Title: "แผ่นหิน",
  app04Title: "ปากกาลูกลื่น",
  app05Title: "กล่องแว่นตา",
  app06Title: "ภาพพิมพ์ไม้",
  app07Title: "กระป๋องเครื่องดื่ม",
  app08Title: "คีย์บอร์ด",
  app09Title: "แก้วเก็บความร้อน",
  app10Title: "กระเป๋าเดินทาง",
  app11Title: "ผลิตภัณฑ์อะคริลิก",
  app12Title: "สมุดบันทึก",
  app13Title: "เหรียญตรา",
  app14Title: "กระเป๋าใส่บัตรหนัง",
  app15Title: "ป้ายชื่อ",
  app16Title: "ศิลปะบนแก้ว",
  appDtgCase01: "เสื้อยืด",
  appDtgCase02: "เสื้อฮู้ด",
  regionCn: "จีน",
  regionUs: "สหรัฐอเมริกา",
  regionGb: "สหราชอาณาจักร",
  regionDe: "เยอรมนี",
  regionAe: "สหรัฐอาหรับเอมิเรตส์",
  regionIn: "อินเดีย",
  regionJp: "ญี่ปุ่น",
  regionVn: "เวียดนาม",
  regionBr: "บราซิล",
  regionAu: "ออสเตรเลีย",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
